import React from "react"
import { NavLink } from "react-router-dom"
import useLogout from "../hooks/auth/useLogout"
import IconFont from "../elements/IconFont"
import PrismancyLogo from './PrismancyLogo'

const CenteredHeader: React.FC = (): React.ReactElement => {

  const logout = useLogout()

  return (
    <div className="ui-panel-header ui-panel-centered-header ui-layer-header relative mx-auto my-[32px] flex w-full items-center gap-[32px] border-b-0 px-[28px]">
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <NavLink to="/" className="flex leading-none">
          <PrismancyLogo variant="icon" />
        </NavLink>
      </div>
      <div className="ml-auto">
        <button onClick={() => logout()} className="flex align-center justify-center gap-2 text-body-muted text-base leading-6 font-semibold">
          <IconFont name="log-out" size={24} className="text-inherit" />
          Log Out
        </button>
      </div>
    </div>
  )
}

export default CenteredHeader
